<template>
  <div
    class="ime-hero"
    :class="{'container': !objP.fullwidth, 'container-fluid': objP.fullwidth, 'heroImage': objC.backgroundtype === 'image', 'heroColor': objC.backgroundtype === 'color'}"
    :style="{'background-attachment': objP.backgroundaction, 'background-image': 'url('+objC.backgroundimage+')'}"
  >
    <div class="row">
      <div class="container hero-wrap">
        <div class="row align-items-center" v-if="objP.contentleft">
          <div class="col" :class="objP.textalignment">
            <div
              v-if="objC.eyebrow"
              class="eyebrow"
              :data-aos="aos('eyebrow', 'type')"
              :data-aos-duration="aos('eyebrow', 'duration')"
              :data-aos-delay="aos('eyebrow', 'delay')"
            >{{ objC.eyebrow }}</div>
            <h1
              v-if="objC.title"
              v-html="objC.title"
              ref="objP.ani"
              :data-aos="aos('title', 'type')"
              :data-aos-duration="aos('title', 'duration')"
              :data-aos-delay="aos('title', 'delay')"
            ></h1>
            <h2
              v-if="objC.subtitle"
              v-html="objC.subtitle"
              :data-aos="aos('subtitle', 'type')"
              :data-aos-duration="aos('subtitle', 'duration')"
              :data-aos-delay="aos('subtitle', 'delay')"
            ></h2>
            <div
              v-if="objC.text"
              class="hero-text"
              v-html="objC.text"
              :data-aos="aos('text', 'type')"
              :data-aos-duration="aos('text', 'duration')"
              :data-aos-delay="aos('text', 'delay')"
            ></div>
            <div class="row" v-if="objP.primarycta || objP.secondarycta">
              <div class="col" :class="objP.textalignment">
                <a
                  v-if="objP.primarycta"
                  :href="objC.primaryctaurl"
                  class="btn solid"
                  :data-aos="aos('primaryctaurl', 'type')"
                  :data-aos-duration="aos('primaryctaurl', 'duration')"
                  :data-aos-delay="aos('primaryctaurl', 'delay')"
                >{{ objC.primaryctatext }}</a>
                <a
                  v-if="objP.secondarycta"
                  :href="objC.secondaryctaurl"
                  class="btn solid"
                  :data-aos="aos('secondaryctaurl', 'type')"
                  :data-aos-duration="aos('secondaryctaurl', 'duration')"
                  :data-aos-delay="aos('secondaryctaurl', 'delay')"
                >{{ objC.secondaryctatext }}</a>
              </div>
            </div>
          </div>
          <div class="col hero-img" :class="objP.graphicalignment" v-if="objC.graphic">
            <img
              :src="objC.graphic"
              :alt="objC.graphicAlt"
              :data-aos="aos('graphic', 'type')"
              :data-aos-duration="aos('graphic', 'duration')"
              :data-aos-delay="aos('graphic', 'delay')"
            />
          </div>
        </div>
        <div class="row align-items-center" v-else>
          <div class="col hero-img" :class="objP.graphicalignment" v-if="objC.graphic">
            <img
              :src="objC.graphic"
              :alt="objC.graphicAlt"
              :data-aos="aos('graphic', 'type')"
              :data-aos-duration="aos('graphic', 'duration')"
              :data-aos-delay="aos('graphic', 'delay')"
            />
          </div>
          <div class="col" :class="objP.textalignment">
            <div
              class="eyebrow"
              v-if="objC.eyebrow"
              :data-aos="aos('eyebrow', 'type')"
              :data-aos-duration="aos('eyebrow', 'duration')"
              :data-aos-delay="aos('eyebrow', 'delay')"
            >{{ objC.eyebrow }}</div>
            <h1
              v-if="objC.title"
              v-html="objC.title"
              :data-aos="aos('title', 'type')"
              :data-aos-duration="aos('title', 'duration')"
              :data-aos-delay="aos('title', 'delay')"
            ></h1>
            <h2
              v-if="objC.subtitle"
              v-html="objC.subtitle"
              :data-aos="aos('subtitle', 'type')"
              :data-aos-duration="aos('subtitle', 'duration')"
              :data-aos-delay="aos('subtitle', 'delay')"
            ></h2>
            <div
              v-if="objC.text"
              class="hero-text"
              v-html="objC.text"
              :data-aos="aos('text', 'type')"
              :data-aos-duration="aos('text', 'duration')"
              :data-aos-delay="aos('text', 'delay')"
            ></div>
            <div
              class="row"
              v-if="objP.primarycta || objP.secondarycta"
              :class="objP.textalignment"
            >
              <div class="col" :class="objP.textalignment">
                <a
                  v-if="objP.primarycta"
                  :href="objC.primaryctaurl"
                  class="btn solid"
                  :data-aos="aos('primaryctaurl', 'type')"
                  :data-aos-duration="aos('primaryctaurl', 'duration')"
                  :data-aos-delay="aos('primaryctaurl', 'delay')"
                >{{ objC.primaryctatext }}</a>
                <a
                  v-if="objP.secondarycta"
                  :href="objC.secondaryctaurl"
                  class="btn solid"
                  :data-aos="aos('secondaryctaurl', 'type')"
                  :data-aos-duration="aos('secondaryctaurl', 'duration')"
                  :data-aos-delay="aos('secondaryctaurl', 'delay')"
                >{{ objC.secondaryctatext }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <video class="bg-video" autoplay muted loop playsinline v-if="objP.bgvideo">
      <source :src="objC.videopath" type="video/mp4" />
    </video>
    <div class="animate-base animate-1" v-if="objC.animate1">
      <img :src="objC.animate1" :alt="objC.anim1Alt" />
    </div>
    <div class="animate-base animate-2" v-if="objC.animate2">
      <img :src="objC.animate2" :alt="objC.anim2Alt" />
    </div>
    <div class="animate-base animate-3" v-if="objC.animate3">
      <img :src="objC.animate3" :alt="objC.anim3Alt" />
    </div>
    <div class="animate-base animate-4" v-if="objC.animate4">
      <img :src="objC.animate4" :alt="objC.anim4Alt" />
    </div>
    <div class="animate-base animate-5" v-if="objC.animate5">
      <img :src="objC.animate5" :alt="objC.anim5Alt" />
    </div>
    <div class="animate-base animate-6" v-if="objC.animate6">
      <img :src="objC.animate6" :alt="objC.anim6Alt" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Hero",
  props: {
    obj: Object
    // {
    //   type: 'Hero', //string name of component
    //   variant: '.variant-1', //string class name for variant
    //   classes: '', //string catch all to add any class names needed to parent container
    //   transitions: {
    //     // Fill out if we are using aos.
    //     // Can do any other visible content item, like subtitle or graphic.
    //     // Content: eyebrow, itle, subtitle, text, graphic, primaryctaurl, secondaryctaurl
    //     // Attributes: type, duration, and delay
    //     aos: {
    //       title: {
    //         type: 'fade-left',
    //         duration: 2000
    //       },
    //       subtitle: {
    //         type: 'fade-right',
    //         delay: 500
    //       }
    //     },
    //     gsap: { // fill out if component requires animation with multiple child elements
    //       components: ['.gs1', '.gs2', '.gs3'], // handle on the animated items within component.
    //       script: '~@assets/script/cloudAnimation'
    //     }
    //   },
    //   presentation: { // component presentational items only
    //     fullwidth: Boolean,
    //     textalignment: 'text-left', // String - Bootstrap class
    //     contentleft: Boolean,
    //     graphicalignment: 'text-center', // String - Bootstrap class
    //     primarycta: Boolean,
    //     secondarycta: Boolean,
    //     bgvideo: Boolean,
    //     backgroundaction: 'scroll' // String - 'scroll' or 'fixed'
    //   },
    //   content: { // component content and images
    //     title: '', // String
    //     subtitle: '', // String
    //     eyebrow: '', // String
    //     text: '', // String
    //     graphic: '', // String - url
    //     graphicAlt: String // alt for graphic
    //     primaryctaurl: 'http://www.google.com',
    //     primaryctatext: 'Get Started',
    //     secondaryctaurl: 'http://www.cnn.com',
    //     secondaryctatext: 'Learn More',
    //     backgroundtype: 'color',
    //     videopath: '',
    //     animate1: String // file path to the asset
    //     anim1Alt: String // alt for animate1
    //     animate2: String // file path to the asset
    //     anim2Alt: String // alt for animate2
    //     animate3: String // file path to the asset
    //     anim3Alt: String // alt for animate3
    //     animate4: String // file path to the asset
    //     anim4Alt: String // alt for animate4
    //     animate5: String // file path to the asset
    //     anim5Alt: String // alt for animate5
    //     animate6: String // file path to the asset
    //     anim6Alt: String // alt for animate6
    //   }
    // }
  },
  computed: {
    objP() {
      return this.obj.presentation;
    },
    objC() {
      return this.obj.content;
    }
  },
  methods: {
    aos(content, attr) {
      // safe traversal, we don't have to define every attribute in the store.
      // Same thing as dog?.action?.bark in other languages.
      return ((this.obj.transitions.aos || {})[content] || {})[attr] || null;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.obj.transitions.gsap.script){
        this.obj.transitions.gsap.script()
      }
    })
  }
};
</script>


<style lang="scss" scoped>
.ime-hero {
  overflow: hidden;
  padding-top: 20px;
  padding-bottom: 20px;
  position: relative;
  .hero-wrap {
    position: relative;
    z-index: 10;
  }
  .bg-video {
    bottom: auto;
    height: auto;
    left: 50%;
    min-height: 100%;
    min-width: 100%;
    position: absolute;
    right: auto;
    top: 50%;
    transform: translate(-50%, -50%);
    width: auto;
    z-index: 9;
  }
}
.heroImage {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
  height: auto;
  margin-bottom: 20px;
  .btn {
    color: #fff;
  }
}
.heroColor {
  background-color: #ccc;
}
</style>
